
import BannerTop from "~/components/home/bannerTop.vue";
import CommonTitle from "~/components/home/commonTitle.vue";
export default {
 name:"klyr20250617",
 components: {
   CommonTitle,
   BannerTop,
   // Notice
 },
 computed: {
  contentList () {
      return this.$t('news.klyr20250617.contentList')
    },
 },
 data() {
  return {
    bannerUrl:require("~/static/images/news/banner.png"),
    imageList: [],
  }
 },
}
